<div
  class="flex justify-between gap-3"
  [class.py-2.5]="!dense()"
  [class.py-1.5]="dense()"
  [class.items-center]="align() === 'center'"
  [class.items-start]="align() === 'start'"
  [class.cursor-pointer]="clickable()"
  [class.hover:bg-surface-hover]="clickable()"
  [class.-mx-1]="clickable()"
  [class.px-1]="clickable()"
  [class.rounded]="clickable()"
  (click)="onClick()"
>
  <div
    class="flex gap-3 min-w-0"
    [class.items-center]="align() === 'center'"
    [class.items-start]="align() === 'start'"
  >
    <ng-content select="[listRowLeading]" />
    @if (icon()) {
      <div
        class="w-11 h-11 rounded-lg flex items-center justify-center flex-none"
        [class.bg-surface-hover]="iconVariant() === 'neutral'"
        [class.bg-surface-highlight]="iconVariant() === 'accent'"
      >
        <mat-icon
          class="!text-2xl !flex !items-center !justify-center"
          [class.text-text-secondary]="iconVariant() === 'neutral'"
          [class.text-brand-primary]="iconVariant() === 'accent'"
        >
          {{ icon() }}
        </mat-icon>
      </div>
    }
    <div class="min-w-0">
      <div class="text-sm font-semibold">{{ title() }}</div>
      <div class="flex items-center gap-2 flex-wrap">
        @if (subtitle()) {
          <div class="text-xs text-muted truncate">{{ subtitle() }}</div>
        }
        <ng-content select="[listRowBadges]" />
      </div>
      <ng-content />
    </div>
  </div>
  <div class="flex items-center gap-1 flex-none">
    <ng-content select="[listRowActions]" />
  </div>
</div>
